import { render, staticRenderFns } from "./hold-talk-wave.vue?vue&type=template&id=1d144609&scoped=true&"
import script from "./hold-talk-wave.vue?vue&type=script&lang=js&"
export * from "./hold-talk-wave.vue?vue&type=script&lang=js&"
import style0 from "./hold-talk-wave.vue?vue&type=style&index=0&id=1d144609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d144609",
  null
  
)

export default component.exports